import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";

export default function DeportationOrRemoval() {
  const { t } = useTranslation();
  const choices = [
    {
      label: t("FUNNEL_DEPORTATION_OR_REMOVAL_CHOICE_YES"),
      value: "YES",
    },
    {
      label: t("FUNNEL_DEPORTATION_OR_REMOVAL_CHOICE_NO"),
      value: "NO",
    },
  ];

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{t("FUNNEL_DEPORTATION_OR_REMOVAL_TITLE_NEW")}</StepTitle>
          <StepSubtitle className="mb-sp-0 mt-sp-1 max-w-full">
            {t("FUNNEL_DEPORTATION_OR_REMOVAL_SUB_TITLE")}
          </StepSubtitle>
          <ChoiceBoxContent
            name={funnelInputsNameMap.deportationOrRemoval}
            choices={choices}
            required
          />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
